<script setup>
import { onBeforeMount, onMounted, ref } from 'vue'
import { initialize, load } from '@/services/onlineProcurementBarService.js'

import configuration from '@/provider/configuration.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars } from '@digitalpa/pro-solid-svg-icons'

library.add(faBars)

const $onlineProcurementBar = ref(null)
const config = configuration.getConfig()
const attributes = config['onlineProcurementBar'].attributes || {}

if (config['onlineProcurementBar']) {
  onBeforeMount(() => {
    load(config['onlineProcurementBar'].url)
  })
  onMounted(() => {
    initialize($onlineProcurementBar, config['onlineProcurementBar'].configuration)
  })
}

</script>

<template>
  <div class="col-12 bg-white d-flex flex-wrap align-items-center op-bar">
    <div ref="$onlineProcurementBar" v-if="config['onlineProcurementBar']">
      <online-procurement-modules-bar v-bind="attributes"></online-procurement-modules-bar>
    </div>
  </div>
</template>

<style scoped></style>
